import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabProchainRDV = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  return (
    <div className="dn-fields">
      <div className="dn-field-group">
        <label>Date du prochain RDV <ConfidenceLabel confidence={gc("prochain_rdv")} /></label>
        <input type="date" value={form.prochain_rdv ?? ""}
          onChange={(e) => onChange("prochain_rdv", e.target.value)}
          style={{ borderColor: gc("prochain_rdv").color || undefined }} />
      </div>
    </div>
  );
};

export default TabProchainRDV;